module.exports = __webpack_public_path__ + "teqbahn-assets/media/FooterImg.777e6083.png";